module.exports = __webpack_public_path__ + "img/63465d519128f97a6fafff6be294f436.svg";